import { defineComponent, ref, computed, onMounted, onUnmounted } from "vue";
import "../../services/main.mjs";
import { roomService } from "../../services/roomService.mjs";
import { EventType } from "../../services/types.mjs";
import { useI18n } from "../../locales/index.mjs";
import { TUIConferenceListManagerEvents } from "@tencentcloud/tuiroom-engine-js";
import { isMobile } from "../../utils/environment.mjs";
import { objectMerge } from "../../utils/utils.mjs";
import "mitt";
import "../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
import SvgIcon from "../common/base/SvgIcon.vue.mjs";
import CalendarIcon from "../common/icons/CalendarIcon.vue.mjs";
import ApplyStageLabelIcon from "../common/icons/ApplyStageLabelIcon.vue.mjs";
import ScheduleRoomControl from "./ScheduleRoomControl.vue.mjs";
import LoadingScheduleIcon from "../common/icons/LoadingScheduleIcon.vue.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ScheduleRoomList",
  props: {
    isShowScheduledConference: { type: Boolean, default: true }
  },
  emits: ["join-conference"],
  setup(__props, { emit }) {
    const props = __props;
    const { t } = useI18n();
    const scheduleRoomList = ref([]);
    const isShowLoading = ref(true);
    const joinConference = (options) => {
      emit("join-conference", options);
    };
    function sortScheduleRoomList() {
      return scheduleRoomList.value.sort(
        (a, b) => a.scheduleStartTime - b.scheduleStartTime
      );
    }
    const sortedScheduleRoomList = computed(() => sortScheduleRoomList());
    const fetchScheduledData = async (cursor = "", result = []) => {
      const res = await roomService.scheduleConferenceManager.fetchScheduledConferenceList({
        cursor,
        count: 20
      });
      (res == null ? void 0 : res.conferenceList) && result.push(...(res == null ? void 0 : res.conferenceList) || []);
      if (res.cursor !== "") {
        await fetchScheduledData(res.cursor, result);
      }
      return result;
    };
    const scheduleContentList = computed(
      () => sortedScheduleRoomList.value.map((item, index, arr) => {
        if (index === 0 || getScheduleDate(item.scheduleStartTime) !== getScheduleDate(arr[index - 1].scheduleStartTime)) {
          return { ...item, showTimestamp: true };
        }
        return { ...item, showTimestamp: false };
      })
    );
    function getScheduleDate(timestamp) {
      const date = new Date(timestamp * 1e3);
      const year = `${date.getFullYear()}`;
      const month = `${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}`;
      const day = `${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()}`;
      return `${year}${t("schedule year")}${month}${t("schedule month")}${day}${t("schedule day")}`;
    }
    function getScheduleTime(timestamp) {
      const date = new Date(timestamp * 1e3);
      const hours = `${date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()}`;
      const minutes = `${date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()}`;
      return `${hours}:${minutes}`;
    }
    const fetchAttendeeList = async (roomId, cursor = "", result = []) => {
      const res = await roomService.scheduleConferenceManager.fetchAttendeeList({
        roomId,
        cursor,
        count: 20
      });
      if (!(res == null ? void 0 : res.attendeeList)) return [];
      result.push(...(res == null ? void 0 : res.attendeeList) || []);
      if (res.cursor !== "") {
        await fetchAttendeeList(roomId, res.cursor, result);
      }
      return result;
    };
    const handleShowMore = async (data) => {
      const attendeeList = await fetchAttendeeList(data.roomId);
      const scheduleRoom = scheduleRoomList.value.find(
        (item) => item.basicRoomInfo.roomId === data.roomId
      );
      if (scheduleRoom) {
        scheduleRoom.scheduleAttendees = attendeeList;
      }
    };
    const fetchData = async () => {
      scheduleRoomList.value = await fetchScheduledData();
      isShowLoading.value = false;
    };
    const updateAttendees = (originList = [], changeData) => {
      const { joinedUsers, leftUsers } = changeData;
      let resultList = [...originList, ...joinedUsers];
      resultList = resultList.filter(
        (attendee) => !leftUsers.some((leftUser) => leftUser.userId === attendee.userId)
      );
      return resultList;
    };
    const onConferenceScheduled = async (data) => {
      const { conferenceInfo } = data;
      const index = scheduleRoomList.value.findIndex(
        (item) => item.basicRoomInfo.roomId === conferenceInfo.basicRoomInfo.roomId
      );
      if (index >= 0) {
        scheduleRoomList.value.splice(index, 1, conferenceInfo);
      } else {
        scheduleRoomList.value.push(conferenceInfo);
      }
    };
    const onConferenceCancelled = async (data) => {
      scheduleRoomList.value = scheduleRoomList.value.filter(
        (item) => item.basicRoomInfo.roomId !== data.roomId
      );
    };
    const onConferenceInfoChanged = async (data) => {
      const aimConferenceIndex = scheduleRoomList.value.findIndex(
        (item) => item.basicRoomInfo.roomId === data.conferenceModifyInfo.basicRoomInfo.roomId
      );
      if (aimConferenceIndex !== -1) {
        scheduleRoomList.value[aimConferenceIndex] = objectMerge(
          scheduleRoomList.value[aimConferenceIndex],
          data.conferenceModifyInfo
        );
      }
    };
    const onScheduleAttendeesChanged = async (data) => {
      const aimConference = scheduleRoomList.value.find(
        (item) => item.basicRoomInfo.roomId === data.roomId
      );
      if (aimConference) {
        aimConference.scheduleAttendees = updateAttendees(
          aimConference.scheduleAttendees,
          data
        );
      }
    };
    const onConferenceStatusChanged = (data) => {
      const aimConference = scheduleRoomList.value.find(
        (item) => item.basicRoomInfo.roomId === data.roomId
      );
      if (aimConference) {
        aimConference.status = data.status;
      }
    };
    onMounted(() => {
      roomService.on(EventType.ROOM_LOGIN, fetchData);
      roomService.scheduleConferenceManager.on(
        TUIConferenceListManagerEvents.onConferenceScheduled,
        onConferenceScheduled
      );
      roomService.scheduleConferenceManager.on(
        TUIConferenceListManagerEvents.onConferenceCancelled,
        onConferenceCancelled
      );
      roomService.scheduleConferenceManager.on(
        TUIConferenceListManagerEvents.onConferenceInfoChanged,
        onConferenceInfoChanged
      );
      roomService.scheduleConferenceManager.on(
        TUIConferenceListManagerEvents.onScheduleAttendeesChanged,
        onScheduleAttendeesChanged
      );
      roomService.scheduleConferenceManager.on(
        TUIConferenceListManagerEvents.onConferenceStatusChanged,
        onConferenceStatusChanged
      );
    });
    onUnmounted(() => {
      roomService.off(EventType.ROOM_LOGIN, fetchData);
      roomService.scheduleConferenceManager.off(
        TUIConferenceListManagerEvents.onConferenceScheduled,
        onConferenceScheduled
      );
      roomService.scheduleConferenceManager.off(
        TUIConferenceListManagerEvents.onConferenceCancelled,
        onConferenceCancelled
      );
      roomService.scheduleConferenceManager.off(
        TUIConferenceListManagerEvents.onConferenceInfoChanged,
        onConferenceInfoChanged
      );
      roomService.scheduleConferenceManager.off(
        TUIConferenceListManagerEvents.onScheduleAttendeesChanged,
        onScheduleAttendeesChanged
      );
      roomService.scheduleConferenceManager.off(
        TUIConferenceListManagerEvents.onConferenceStatusChanged,
        onConferenceStatusChanged
      );
    });
    return { __sfc: true, t, scheduleRoomList, emit, isShowLoading, joinConference, props, sortScheduleRoomList, sortedScheduleRoomList, fetchScheduledData, scheduleContentList, getScheduleDate, getScheduleTime, fetchAttendeeList, handleShowMore, fetchData, updateAttendees, onConferenceScheduled, onConferenceCancelled, onConferenceInfoChanged, onScheduleAttendeesChanged, onConferenceStatusChanged, SvgIcon, CalendarIcon, ApplyStageLabelIcon, ScheduleRoomControl, LoadingScheduleIcon, isMobile };
  }
});
export {
  _sfc_main as default
};
